export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 11.999C3 7.029 7.03 3 12 3s9 4.03 9 8.999c0 .574-.06 1.129-.16 1.661a9.019 9.019 0 01-4.295 6.102h-.002a8.946 8.946 0 01-8.847.131L2.48 21.52l1.627-5.214A8.915 8.915 0 013 11.999zM12 5a7 7 0 00-7 6.999c0 1.343.384 2.592 1.043 3.658l.24.388-.758 2.43 2.429-.757.387.238a6.946 6.946 0 007.19.082 7.019 7.019 0 003.344-4.746A7.01 7.01 0 0019 12 7 7 0 0012 5z\" fill=\"#7B61FF\"/><path d=\"M9 12a1 1 0 11-2 0 1 1 0 012 0zM13 12a1 1 0 11-2 0 1 1 0 012 0zM17 12a1 1 0 11-2 0 1 1 0 012 0z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};